import PageTitle from "../../common/pagetitle/pagetitle";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatDateAndTime, serverLink} from "../../url";
import { connect } from "react-redux";
import DataTable from "../../common/data-table/data-table";
import Loader from "../../common/loader";
import {Link} from "react-router-dom";
import {setAdmissionDetails, setGeneralDetails} from "../../../action/actions";

function InpatientList(props) {
    const token = props.loginData[0]?.token;
    const [IsLoading, setIsLoading] = useState(true);
    const [patientList, setPatientList] = useState([]);

    const header = [
        "S/N",
        "Patient Name",
        "Patient ID",
        "Block Name",
        "Room Name",
        "Bed Name",
        "Admission Status",
        "Admitted On",
        "Action"
    ];

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        await axios.get(`${serverLink}admission/inpatient/list`, token).then((result) => {
                if (result.data.length > 0) {
                    setPatientList(result.data.sort((a, b) => {
                        return a.admissionStatus.localeCompare(b.admissionStatus);
                    }));
                } else {
                    setPatientList([]);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    };

    const showTable = () => {
        try {
            return patientList.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.patientName}</td>
                        <td>{item.patientSerial}</td>
                        <td>{item.blockName}</td>
                        <td>{item.roomName}</td>
                        <td>{item.bedName}</td>
                        <td className={item.admissionStatus === 'Active' ? 'text-success' : 'text-danger'}>{item.admissionStatus}</td>
                        <td>{formatDateAndTime(item.admittedOn, 'date')}</td>
                        <td className="d-flex">
                            <Link to={`/${props.access?.toLowerCase()}/inpatient/dashboard/${btoa(item.admissionID)}`}
                                  className={"btn btn-info btn-sm  mr-3"}
                            >
                                Dashboard
                            </Link>
                        </td>
                    </tr>
                );
            });
        } catch (e) {
            alert(e.message);
        }
    };

    return IsLoading ? (
        <Loader />
    ) : (
        <>
            <PageTitle title={["Home", "Inpatient"]} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Inpatient List</h4>
                                <div className="d-flex no-block align-items-center m-b-30 mt-3">
                                    <div className="ml-auto">
                                    </div>
                                </div>
                                <DataTable
                                    tableID="InPatient"
                                    header={header}
                                    body={showTable()}
                                    title="Inpatient Report"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        setOnAdmissionDetails: (p) => {
            dispatch(setAdmissionDetails(p));
        }
    };
};


const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
        dashboardData: state.DashboardData,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(InpatientList);
